import { render } from "./SurveyDiff.vue?vue&type=template&id=75300f20"
import script from "./SurveyDiff.vue?vue&type=script&lang=js"
export * from "./SurveyDiff.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__